import script from "./FiltroTipoChamado.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltroTipoChamado.vue?vue&type=script&setup=true&lang=js"

import "./FiltroTipoChamado.vue?vue&type=style&index=0&id=3e99b8fc&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e99b8fc"]])

export default __exports__